import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { systemCode, urls } from '..';
import { getConfiguration } from '../data/utils/configuration';
import { getDBTimestampFromDate } from '../data/utils/getDBTimestampFromDate';
import { getPrematchAggs } from '../data/utils/getPrematchAggs';
import { getPrincipaleOPrimoGruppo } from '../data/utils/getPrincipaleOPrimoGruppo';
import { parseIntFromString } from '../data/utils/parseIntFromString';
import { useTimeline } from './matches-by-date/TimelineProvider';
import { useIsMainSection } from '../common/IsMainSectionProvider';
import { getLabel } from '../data/labels';
import XRouterLink from '../common/seo/xrouter/XRouterLink';
import PrematchLinksWh from './PrematchLinksWh';

function AllButton(props) {
    const isMainSection = useIsMainSection();
    const location = useLocation();
    const currentSearch = location.search || "";
    const pathParts = location.pathname.split('/').filter(Boolean);
    const pathSportId = pathParts[2] && !isNaN(pathParts[2]) ? parseInt(pathParts[2], 10) : props.sportId;

    return (
        <>
            {isMainSection ? (
                <XRouterLink
                    to={`${urls.base}/${urls.prematch.base}/${pathSportId}${currentSearch}`}
                    className="relative pb-[4px] min-w-[36px] inline-flex flex-col items-center font-bold uppercase"
                >
                    <span className="my-auto text-xs text-cs4">{getLabel('prematch_page.temporal_filters.all')}</span>
                    <div className="absolute bottom-0 h-[4px] w-full self-center bg-cs4 rounded-t-lg"></div>
                </XRouterLink>
            ) : (
                <XRouterLink
                    to={`${urls.base}/${urls.prematch.base}/${pathSportId}${currentSearch}`}
                    className="pb-[4px] min-w-[36px] inline-flex flex-col items-center font-bold uppercase"
                >
                    <span className="my-auto text-xs text-cs3">{getLabel('prematch_page.temporal_filters.all')}</span>
                </XRouterLink>
            )}
        </>
    );
}

const hoursButtons = [1, 3];
export const descFromHour = {
    1: getLabel('prematch_page.temporal_filters.1h', '1H'),
    3: getLabel('prematch_page.temporal_filters.3h', '3H'),
};

export default function DateSelectionNavbarAlt(props) {
    const params = useParams();
    const location = useLocation();
    const currentSearch = location.search || "";
    const timeline = useTimeline();
    const conf = getConfiguration();
    // const baseUrl = `${urls.basename}/${urls.prematch.base}/${urls.prematch.date}`;
    const today = getDBTimestampFromDate(new Date()).slice(0, 8);
    const hoursToday = timeline.weekDays[0];
    const reorderedDays = timeline.weekDays.reduce((acc, day) => {
        if (day.id === 8) {
            return [day, ...acc];
        }
        return [...acc, day];
    }, []);
    const [refreshToggle, setRefreshToggle] = useState(false);

    useEffect(() => {
        const element = document.getElementById('scrollSelected');
        element?.scrollIntoView({ inline: 'center' });
    }, [params, refreshToggle]);

    if (timeline == null) {
        return null;
    }

    const selectedDate = params.date || '';
    const selectedHour = params.hour || '';


    return (
        <>
            {conf.iwh && systemCode !== 'SUREBET' && (
                <div className="prematchLinks__wrapper">
                    <PrematchLinksWh />
                </div>
            )}
            <div className="xs_dateSelectionNavbar w-full overflow-x-auto px-2 grid grid-flow-col auto-cols-auto bg-cs1 border-y border-y-cc7">
                {conf.iwh && (
                    <XRouterLink
                        to={`${urls.base}/${urls.live.base}`}
                        className="relative pb-[4px] min-w-[36px] inline-flex flex-col items-center font-bold uppercase"
                    >
                        <span className="my-auto text-xs text-cs4 livebutton__wh">Live</span>
                        <div className="absolute bottom-0 h-[4px] w-full self-center bg-cs4 rounded-t-lg"></div>
                    </XRouterLink>
                )}
                <div className="flex items-center content-center justify-center allBtn">
                    <AllButton sportId={props.sportId} />
                </div>
                {hoursButtons.map((b) => {
                    const d = hoursToday;
                    let [sportId, aggId] = [d.sport.id, d.sport.aggregata];
                    if (params.sportId != null) {
                        if (params.aggId == null) {
                            const sportIdInt = parseIntFromString(params.sportId);
                            let aggs = getPrematchAggs(sportIdInt);
                            aggs = Array.from(Object.values(aggs));
                            const agg = getPrincipaleOPrimoGruppo(aggs);
                            sportId = params.sportId;
                            aggId = agg.idAggregata;
                        } else {
                            sportId = params.sportId;
                            aggId = params.aggId;
                        }
                    }
                    const dateAndHour = `${d.date}-${b}`;
                    let dayUrl = props.openAllMatches
                        ? `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.allMatches}/${dateAndHour}/${sportId}/${aggId}`
                        : `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${dateAndHour}/${sportId}/${aggId}`;
                    dayUrl = dayUrl + currentSearch;

                    const isActive = params.date === dateAndHour
                    return (
                        <XRouterLink
                            onClick={() => setRefreshToggle(prev => !prev)}
                            key={`${d.date}-${b}`}
                            to={dayUrl}
                            className={`pb-[4px] min-w-[36px] inline-flex flex-col items-center font-bold uppercase relative dateHour--${b} ${isActive ? 'active' : ''}`}
                        >
                            <span className={`my-auto text-xs !uppercase ${isActive ? 'text-cs4' : 'text-cs3'}`}>
                                +{descFromHour[b]}
                            </span>
                            {isActive && (
                                <div className="absolute bottom-0 h-[4px] w-full self-center bg-cs4 rounded-t-lg"></div>
                            )}
                        </XRouterLink>
                    );
                })}
                {reorderedDays.map((d) => {
                    let [sportId, aggId] = [d.sport.id, d.sport.aggregata];
                    if (params.sportId != null) {
                        if (params.aggId == null) {
                            const sportIdInt = parseIntFromString(params.sportId);
                            let aggs = getPrematchAggs(sportIdInt);
                            aggs = Array.from(Object.values(aggs));
                            const agg = getPrincipaleOPrimoGruppo(aggs);
                            sportId = params.sportId;
                            aggId = agg.idAggregata;
                        } else {
                            sportId = params.sportId;
                            aggId = params.aggId;
                        }
                    }
                    let url = props.openAllMatches
                        ? `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.allMatches}/${d.date}/${sportId}/${aggId}`
                        : `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${d.date}/${sportId}/${aggId}`;

                    url = url + currentSearch;

                    const isActive = selectedDate === d.date && !selectedHour;

                    return (
                        <XRouterLink
                            key={d.id}
                            to={url}
                            className={`pb-[4px] min-w-[36px] inline-flex flex-col items-center font-bold uppercase relative ${isActive ? 'active' : ''}`}
                        >
                            {d.date === today ? (
                                <span className={`my-auto text-xs ${isActive ? 'text-cs4' : 'text-cs3'}`}>
                                    {getLabel('prematch_page.temporal_filters.today')}
                                </span>
                            ) : (
                                <span className={`text-xs ${isActive ? 'text-cs4' : 'text-cs3'}`}>
                                    {d.id === 8 ? '+48H' : d.desc}
                                </span>
                            )}
                            {isActive && (
                                <div className="absolute bottom-0 h-[4px] w-full self-center bg-cs4 rounded-t-lg"></div>
                            )}
                        </XRouterLink>
                    );
                })}
            </div>
        </>
    );
}